import React from 'react';
import { AtdwCellarDoorMap } from './view/atdwCellarDoorMap';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'AtdwCellarDoorMap',
  itemElt: (item, cmsOption) => <AtdwCellarDoorMap item={item} cmsOption={cmsOption} />
}